import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Pricing = () => {
  useEffect(() => {
    const scriptId = 'stripe-pricing-table';

    // Prevent loading script more than once
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js.stripe.com/v3/pricing-table.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
    
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: 'Segoe UI, sans-serif', background: '#000000', minHeight: '100vh' }}>
      <header
        style={{
          padding: '2rem',
          backgroundColor: '#0074d4',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap', // handles responsiveness on smaller screens
          gap: '1.5rem',
          textAlign: 'left',
        }}
      >
        <img
          src="/rocket-stacked-white.png"
          alt="Rocket Offer Logo"
          style={{ height: '80px', width: 'auto' }}
        />
        <div>
          <h1 style={{ margin: '0 0 0.5rem 0' }}>Choose Your Rocket Offer Plan</h1>
          <p style={{ margin: 0 }}>Straightforward pricing for yearly or monthly subscriptions</p>
        </div>
      </header>


    <main
      style={{
        maxWidth: '1440px',
        width: '100%',
        margin: '2rem auto',
        padding: '0 1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'black',
        color: 'white'
      }}
    >
      <section
        style={{
          color: '#fff',
          backgroundColor: '#111',
          padding: '1.5rem',
          borderRadius: '8px',
          maxWidth: '800px',
          width: '100%',
          marginBottom: '2rem',
          textAlign: 'center',
        }}
      >
        <p style={{ fontSize: '0.95rem', marginBottom: '0.5rem' }}>
          By subscribing, you agree to our{' '}
          <a
            href="/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4dabf7', textDecoration: 'underline' }}
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4dabf7', textDecoration: 'underline' }}
          >
            Privacy Policy
          </a>.
        </p>
      </section>
      <stripe-pricing-table
        pricing-table-id="prctbl_1RiF8GJe0QwMbMTshKp2gTMo"
        publishable-key="pk_live_51RVuaaJe0QwMbMTsm5U2EzI2Nd6tC8KHkpfFriwLkmSvq17n0KxAZYCgO8S2Jz4uAXR0xz5vuvamVSUiNbNByKZY00GY3FBTRd"
        style={{ width: '100%' }}
      ></stripe-pricing-table>

      {/* 👇 Free plan call-to-action section */}
      <section
        style={{
          backgroundColor: '#111',
          borderRadius: '8px',
          padding: '2rem',
          marginTop: '2rem',
          maxWidth: '800px',
          textAlign: 'center',
        }}
      >
        <h2 style={{ marginBottom: '0.5rem' }}>Want to Start Free?</h2>
        <p style={{ marginBottom: '1.5rem' }}>
          The Rocket Offer Free Plan lets list your home or property and explore Rocket Offer tools for free with no commitment. Perfect for the homeowner who needs offers fast.
        </p>
        <button
          onClick={() => navigate('/thank-you')}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#0074d4',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            fontSize: '1rem',
            cursor: 'pointer',
          }}
        >
          Subscribe to Free Plan
        </button>
      </section>
    </main>


      <footer style={{ textAlign: 'center', color: '#888', padding: '1.5rem' }}>
        &copy; {new Date().getFullYear()} Rocket Offer. All rights reserved.
      </footer>
    </div>
  );
};

export default Pricing;
